module.exports = __webpack_public_path__ + "static/media/favicon-uzabase826.7d7605b9.ico";